import React, { useEffect, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { chatgenieAPI } from 'src/config/api';
import { queryClient } from 'src/config/queryClient';
import useToast from 'src/hooks/useToast';
import queryKeys from 'src/constants/queryKeys';
import { BoardTypeFieldContext } from '../boardContext';
import BoardTypeTable from './BoardTypeTable';

export const AutoCatTicketTypeTable = () => {
  const { toast } = useToast();
  const [currentField, setCurrentField] = useState({
    id: null,
    key: null
  });
  const [haloTicketTypesState, setHaloTicketTypesState] = useState({
    types: []
  });

  const { data: ticketTypesData } = useQuery([queryKeys.GET_ALL_TICKET_TYPES], () =>
    chatgenieAPI.getAllTicketTypes().then(data => {
      return { types: data };
    })
  );

  const { mutate, isLoading } = useMutation(chatgenieAPI.bulkUpdateTicketTypes, {
    onSuccess(updatedData) {
      queryClient.setQueryData([queryKeys.GET_ALL_TICKET_TYPES], () => {
        return { types: updatedData };
      });
    },
    onError: err => {
      toast.error(
        `Failed to save categorization types: ${err?.response?.data?.message || err?.message}`
      );
      queryClient.invalidateQueries([queryKeys.GET_ALL_TICKET_TYPES]);
    }
  });

  const handleTicketTypeChange = ({ id, values }) => {
    setHaloTicketTypesState(old => ({
      ...old,
      types: old.types.map(type => (type.id === id ? { ...type, ...values } : type))
    }));
  };

  const handleTicketTypeBlur = ({ id, key, value }) => {
    const ticketType = ticketTypesData?.types?.find(el => el.id === id);
    const isValueStale = ticketType[key] !== value;
    if (isValueStale) {
      setCurrentField({ id, key });
      mutate(ticketTypesData?.types?.map(el => (el.id === id ? { ...el, [key]: value } : el)));
    }
  };

  const ticketTypeContextValue = {
    onBlur: handleTicketTypeBlur,
    currentField,
    isLoading,
    showTableHeader: false,
    showAccordionHeader: false
  };

  useEffect(() => {
    setHaloTicketTypesState(ticketTypesData);
  }, [ticketTypesData]);

  return (
    <BoardTypeFieldContext.Provider value={ticketTypeContextValue}>
      <BoardTypeTable
        data={haloTicketTypesState ? [haloTicketTypesState] : null}
        onChange={handleTicketTypeChange}
      />
    </BoardTypeFieldContext.Provider>
  );
};
